import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "Inter, sans-serif",
  },
  palette: {
    primary: {
      main: "#005EFF",
      light: "rgba(0, 94, 255, 0.1)",
    },
    secondary: {
      main: "#0452D7",
    },
    success: {
      main: "#00B221",
      light: "rgba(0, 178, 33, 0.1)",
    },
    error: {
      main: "#FE0909",
      light: "rgba(254, 9, 9, 0.1)",
    },
    warning: {
      main: "#F39600",
      light: "rgba(243, 150, 0, 0.1)",
    },
    info: {
      main: "#8A2BE2",
      light: "rgba(138, 43, 226, 0.1)",
    },
    grey: {
      50: "#F4F4F4",
      100: "rgba(74, 85, 101, 0.1)",
      500: "#61708A",
      700: "#4A5565",
    },
    background: {
      default: "#F9FAFB",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#000814",
    },
  },
});

export default theme;